import { Button, Form, Input, Select } from "antd";

export function RegisterForm({ loading, form, onSubmit }) {
  return (
    <Form form={form} layout="vertical" onFinish={onSubmit} autoComplete="off">
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Vui lòng nhập email!" },
          { type: "email", message: "Email không hợp lệ!" },
        ]}
      >
        <Input size="large" placeholder="Nhập email" />
      </Form.Item>

      <Form.Item
        label="Mật khẩu"
        name="password"
        rules={[
          { required: true, message: "Vui lòng nhập mật khẩu!" },
          {
            pattern: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
            message:
              "Mật khẩu phải có ít nhất 8 ký tự, bao gồm 1 chữ hoa và 1 số!",
          },
        ]}
      >
        <Input.Password size="large" placeholder="Nhập mật khẩu" />
      </Form.Item>

      <Form.Item
        label="Tên"
        name="name"
        rules={[
          { required: true, message: "Vui lòng nhập tên!" },
          { min: 2, max: 50, message: "Tên phải từ 2 đến 50 ký tự!" },
        ]}
      >
        <Input size="large" placeholder="Nhập tên" />
      </Form.Item>

      <Form.Item
        label="Vai trò"
        name="role"
        rules={[{ required: true, message: "Vui lòng chọn vai trò!" }]}
      >
        <Select size="large" placeholder="Chọn vai trò">
          <Select.Option value="admin">Quản trị viên</Select.Option>
          <Select.Option value="staff">Cộng tác viên</Select.Option>
          <Select.Option value="user">Thành Viên</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Giới tính"
        name="gender"
        rules={[{ required: true, message: "Vui lòng chọn giới tính!" }]}
      >
        <Select size="large" placeholder="Chọn giới tính">
          <Select.Option value="male">Nam</Select.Option>
          <Select.Option value="female">Nữ</Select.Option>
          <Select.Option value="other">Khác</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Số điện thoại"
        name="phone"
        rules={[
          { required: true, message: "Vui lòng nhập số điện thoại!" },
          { pattern: /^\d{10,15}$/, message: "Số điện thoại không hợp lệ!" },
        ]}
      >
        <Input size="large" placeholder="Nhập số điện thoại" />
      </Form.Item>

      <Form.Item label="Địa chỉ" name="address">
        <Input size="large" placeholder="Nhập số địa chỉ" />
      </Form.Item>

      <Form.Item>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          loading={loading}
          block
          style={{ marginTop: 8 }}
        >
          Đăng ký
        </Button>
      </Form.Item>
    </Form>
  );
}
